import { render } from "./AddFundsModal.vue?vue&type=template&id=1a604910"
import script from "./AddFundsModal.vue?vue&type=script&lang=js"
export * from "./AddFundsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__